import React, {useEffect, useState} from 'react';
import {Exhibit} from "types/Exhibit";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useOperator} from "context/OperatorContext";
import {useNotifications} from "context/NotificationContext";

type Props = {
    exhibit: Exhibit | null
    show: boolean
    onDelete?: (exhibit: Exhibit) => any
    onDeleteFail?: (exhibit: Exhibit, error: unknown) => any
    onCancel?: () => any
}

function DeleteExhibit(props: Props) {
    const {exhibit, show, onDelete, onDeleteFail, onCancel} = props

    const {termFor} = useOperator()
    const {notify} = useNotifications()

    const [name, setName] = useState<string>(exhibit?.name || `this ${termFor('exhibit')}`);
    const {mutateAsync: deleteExhibit} = useMutation(ngage.exhibits.destroy)

    useEffect(() => {
        if(exhibit) setName(exhibit.name)
    }, [exhibit]);

    async function handleDeleteExhibit() {
        if (exhibit) {
            try {
                await deleteExhibit(exhibit.id)
                await invalidate('exhibits.all')

                notify("success", `${termFor('Exhibit')} Deleted`, `${exhibit.name} has been permanently removed`)
                if (onDelete) onDelete(exhibit)
            } catch (error) {
                notify("error", `${termFor('Exhibit')} Not Deleted`, `${exhibit.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(exhibit, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={`Delete ${termFor('Exhibit')}`}
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteExhibit}
            onCancel={handleCancel}
        />
    );
}

export default DeleteExhibit;